import { useQuery } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

// 팝업 상세 조회
export const useGetPopup = (idx: string) => {
    return useQuery({
        queryKey: ["popupDetail", idx],
        queryFn: async () => {
            const res = await consoleAxios.get(CONSOLE_API_ROUTES.POPUP_DETAIL.replace(":idx", idx));
            return res.data;
        },
        enabled: !!idx, // idx가 있을 때만 실행
    });
};
